import {SizeProp} from "@fortawesome/fontawesome-svg-core";
import {AavoLoading} from "./AavoLoading";
import {Box, BoxProps} from "@mui/material";
import {mergeSx} from "src/utils/styles";
import {overlaySx} from "src/styles/sx";

export interface LoadingBoxProps extends BoxProps {
    size?: SizeProp;
    overlay?: boolean;
}

export const LoadingBox = ({size, overlay, sx, ...other}: LoadingBoxProps) => {
    return (
        <Box
            sx={mergeSx(
                {
                    display: "flex",
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    color: "primary.main",
                },
                overlay && {
                    ...overlaySx,
                    zIndex: 100,
                    backgroundColor: "rgba(255,255,255,0.7)",
                    backdropFilter: "blur(1px)",
                },
                sx
            )}
            {...other}
        >
            <AavoLoading size={size || "3x"}/>
        </Box>
    );
};
